
import { AdminDashboard } from "@/components/AdminDashboard";
import { useAuth } from "@/hooks/useAuth";
import { useLoginForm } from "@/hooks/useLoginForm";
import { useLoginRedirect } from "@/hooks/useLoginRedirect";
import { AccessDeniedCard } from "@/components/AreaPaciente/AccessDeniedCard";
import { LoadingScreen } from "@/components/AreaPaciente/LoadingScreen";
import { AreaPacienteLayout } from "@/components/AreaPaciente/AreaPacienteLayout";

export function AreaPacienteContent() {
  const { user, loading: authLoading, isAdmin } = useAuth();
  const {
    email,
    setEmail,
    password,
    setPassword,
    isLoading,
    justLoggedIn,
    setJustLoggedIn,
    handleSubmit
  } = useLoginForm();
  
  const { isAdminPanel } = useLoginRedirect({
    user,
    authLoading,
    justLoggedIn,
    isAdmin,
    setJustLoggedIn
  });

  if (authLoading) {
    return <LoadingScreen />;
  }

  // Se usuário está logado e é admin acessando painel admin
  if (user && isAdminPanel && isAdmin && !justLoggedIn) {
    return <AdminDashboard />;
  }

  // Se usuário está logado mas não é admin e está tentando acessar painel admin
  if (user && isAdminPanel && !isAdmin && !justLoggedIn) {
    return <AccessDeniedCard />;
  }

  // Página de login normal
  return (
    <AreaPacienteLayout
      isAdminPanel={isAdminPanel}
      showLoginForm={true}
      loginFormProps={{
        email,
        setEmail,
        password,
        setPassword,
        isLoading,
        onSubmit: handleSubmit
      }}
    />
  );
}
